function ExpectedArrivalReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">ExpectedArrivalReport</div>
      </>
    );
  }
  
  export default ExpectedArrivalReport;